"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoPlacementJob = exports.AutoPlacementIterationResult = void 0;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
const api_1 = require("../auto-placement/api");
const identifier_1 = require("../identifier");
// NOTE: needs to be accumulated
exports.AutoPlacementIterationResult = zod_1.default.object({
    componentPlacements: zod_1.default
        .array(zod_1.default.object({
        componentDesignator: zod_1.default.string().describe("designator of the component to place."),
        position: zod_1.default
            .object({
            x: zod_1.default.number().describe("position.x in mm"),
            y: zod_1.default.number().describe("position.y in mm"),
        })
            .describe("new position of the component in the 2-dimensional coordinate space of its layer."),
        rotation: zod_1.default
            .number()
            .describe("new component rotation in the 2-dimensional coordinate space of the layer, in degrees CCW."),
        layer: zod_1.default.enum(["top", "bottom"]).describe("new assigned layer the component should be placed on"),
    }))
        .describe("placements for each component that should have its placement changed"),
    result: zod_1.default
        .enum(["FAILURE", "APPLY_CHANGES", "NO_CHANGES_DONE"])
        .describe("Select the appropriate value for what should be done with your output."),
    resultExplanation: zod_1.default.string().describe("A brief explanation why you picked the selected result value."),
    iterationUid: zod_1.default.string(),
    iterationIndex: zod_1.default.number(),
    timestamp: zod_1.default.number(),
});
exports.AutoPlacementJob = zod_1.default.object({
    projectUid: zod_1.default.string(),
    jobUid: api_1.autoPlacementJobUidSchema,
    submittedByUserUid: identifier_1.UserUid,
    userOrganizationUid: identifier_1.optionalOrganizationUid,
    type: zod_1.default.literal("autoPlacement"),
    createAt: zod_1.default.number(),
    updatedAt: zod_1.default.number(),
    active: zod_1.default.boolean(),
    jobStatus: zod_1.default.enum(["pending", "running", "paused", "failed", "complete", "cancelled"]),
    iterations: zod_1.default.array(exports.AutoPlacementIterationResult),
});
//# sourceMappingURL=autoPlacement.js.map